import React from "react"
import { cn } from "../styles/utils"
import { Icon } from "./Icons"
import { Pressable } from "./Pressable"

export interface CloseButtonProps {
  onPress: () => void
  variant?: "modal" | "drawer" | "default"
  size?: "sm" | "md" | "lg"
  className?: string
  iconClassName?: string
  disabled?: boolean
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  onPress,
  variant = "default",
  size = "md",
  className,
  iconClassName,
  disabled = false,
}) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "modal":
        return "absolute -top-5 -right-5 bg-background-0 rounded-full shadow-sm"
      case "drawer":
        return "relative"
      case "default":
        return "relative"
      default:
        return "relative"
    }
  }

  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return "p-1"
      case "md":
        return "p-2"
      case "lg":
        return "p-3"
      default:
        return "p-2"
    }
  }

  const getIconSizeClasses = () => {
    switch (size) {
      case "sm":
        return "h-4 w-4"
      case "md":
        return "h-6 w-6"
      case "lg":
        return "h-8 w-8"
      default:
        return "h-6 w-6"
    }
  }

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      className={cn(
        "items-center justify-center rounded-md",
        "hover:bg-background-100 active:bg-background-200",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        getVariantClasses(),
        getSizeClasses(),
        className,
      )}
    >
      <Icon
        name="x-mark"
        className={cn(
          "text-typography-500",
          getIconSizeClasses(),
          iconClassName,
        )}
      />
    </Pressable>
  )
}
